import { PeriodTypeEnum } from '@schooly/api';
import { v4 as uuidv4 } from 'uuid';

import { TimetableStructurePeriodForm } from '../../../../../context/timetableStructure/WithTimetableStructure';

export const createNewPeriod = (start_time = '', end_time = ''): TimetableStructurePeriodForm => {
  return {
    id: uuidv4(),
    name: '',
    start_time,
    end_time,
    type: PeriodTypeEnum.Lesson,
    register_session: null,
  };
};
